import "./App.css";
import LogHistory from "./Inventory/LogHistory";
import CountSheet from './Inventory/Inventories/CountSheet';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ClosedHistory from "./Inventory/Inventories/ClosedHistory/ClosedHistory";
import IFrame from "./IFrame";
import Products from "./Inventory/Products/Products";
import { ToastContainer } from "react-toastify";
import AddAndEditCountSheet from "./Inventory/CountSheet/AddAndEditCountSheet";
import InventoriesDetails from "./Inventory/Inventories/InventoriesDetails";
import { OverallCountSheet } from "./Inventory/CountSheet/OverallCountSheet";
import Reconciliation from "./BillPay/Reconciliation";
import Invoices from "./BillPay/Invoices";
import Payments from "./BillPay/Payments";
import Setup from "./BillPay/Setup";
function App() {

  window.onload = function () {
    function notifyParent() {
      window.parent.postMessage({ idle: false }, '*');
    }

    window.addEventListener('mousemove', notifyParent);
    window.addEventListener('keydown', notifyParent);
    window.addEventListener('scroll', notifyParent);
  };

  return (
    <>
      <ToastContainer autoClose={1500} limit={0} />
      <Router>
        <Routes>
          <Route path="/" element={<LogHistory />} />
          <Route path="/bill_pay" element={<LogHistory />} />
          <Route path="/inventories/:Inventory_date" element={<CountSheet />} />
          <Route path="/history/:Date" element={<ClosedHistory />} />
          <Route path="/iframe" element={<IFrame />} />
          {/* <Route path="/add-and-edit-countsheet" element={<OverallCountSheet />} /> */}
          {/* <Route path="/products" element={<Products />} />
          <Route path="/history-table" element={<HistoryTable />} />
          <Route path="/countsheet" element={<OverallCountSheet />} />
          <Route path="/reconciliation" element={<Reconciliation />} />
          <Route path="/invoices" element={<Invoices />} />
          <Route path="/payments" element={<Payments />} />
          <Route path="/setup" element={<Setup />} /> */}
        </Routes>
      </Router>
    </>
  );
}

export default App;
